'use client';

import { ConfirmationDialog } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';

export function TracesDeleteDialog({
  isOpen,
  loading,
  count = 1,
  onOpenChange,
  onConfirm,
}: {
  isOpen: boolean;
  loading: boolean;
  count?: number;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}) {
  const tCommon = useTranslations('designSystem.common');
  const tExecutions = useTranslations('designSystem.executions');
  const isBulk = count > 1;

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onOpenChange={({ open }) => onOpenChange(open)}
      onConfirm={onConfirm}
      loading={loading}
      variant="destructive"
      title={tExecutions('delete.title')}
      description={
        isBulk
          ? tExecutions('delete.confirmMessage', { count })
          : tExecutions('delete.warning')
      }
      confirmText={
        isBulk ? tExecutions('delete.button', { count }) : tCommon('delete')
      }
      cancelText={tCommon('cancel')}
    />
  );
}
